<template lang="html">
  <div class="flex justify-center items-center">
    <h1 class="text-4xl">404 Not Found!</h1>
  </div>
</template>

<script>
export default {
  name: '404'
}
</script>

<style lang="css" scoped>
</style>
